import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { ReceiptReportItemDto } from "@/api/dtos";
import type { ReceiptReportItem } from "./_models/ReceiptReport";
import { toReceiptReportItemFromDto } from "./_transformers/toReceiptReportItemFromDto";

/** One receipt report file, parsed into rows; the name "latest" (LATEST) resolves to the newest file. */
export const getReceiptReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReceiptReport: builder.query<ReceiptReportItem[], string>({
      queryFn: async (name) => {
        try {
          const res = await axios.get<ReceiptReportItemDto[]>(
            `${backendBase()}/receipt-reports/${encodeURIComponent(name)}`,
            { headers: { Accept: "application/json" } },
          );
          const rows = res.data.map((x) => toReceiptReportItemFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: (_result, _error, name) => [
        { type: ReportTags.ReceiptReport, id: name },
      ],
    }),
  }),
});

export const getReceiptReport = getReceiptReportApi.endpoints.getReceiptReport;
